// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
//   Box
// } from "@mui/material";
// import { useEffect, useState } from "react";

// const KycUploadModal = ({ open, onClose, onSubmit ,initialData}) => {
//   // const [data, setData] = useState({
//   //   aadhaar: "",
//   //   pan: "",
//   //   aadhaarFront: null,
//   //   aadhaarBack: null,
//   //   panFile: null
//   // });

//   const [data, setData] = useState({
//   aadhaar: "",
//   pan: "",
//   aadhaarFront: null,
//   aadhaarBack: null,
//   panFile: null,

//   aadhaarFrontUrl: "",
//   aadhaarBackUrl: "",
//   panFileUrl: ""
// });

// useEffect(() => {
//   if (initialData) {
//     setData(prev => ({
//       ...prev,
//       ...initialData
//     }));
//   }
// }, [initialData]);

//   // Handle Aadhaar & PAN input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "aadhaar") {
//       // Allow only numbers, max 12 digits
//       if (/^\d*$/.test(value)) {
//         setData((prev) => ({ ...prev, aadhaar: value.slice(0, 12) }));
//       }
//     } else if (name === "pan") {
//       // Uppercase, remove spaces
//       setData((prev) => ({ ...prev, pan: value.toUpperCase().trim() }));
//     }
//   };

//   // Handle file selection
//   const handleFile = (e) => {
//     const { name, files } = e.target;
//     setData((prev) => ({ ...prev, [name]: files[0] }));
//   };

//   // Validate and submit
//   const submit = () => {
//     const { aadhaar, pan, aadhaarFront, aadhaarBack, panFile } = data;

//     if (aadhaar.length !== 12) {
//       alert("Aadhaar must be 12 digits");
//       return;
//     }

//     if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan)) {
//       alert("Invalid PAN format");
//       return;
//     }

//     if (!aadhaarFront || !aadhaarBack || !panFile) {
//       alert("All documents are required");
//       return;
//     }

//     onSubmit(data);
//     onClose();
//   };

//   const previewSrc =
//   data[f.key]
//     ? URL.createObjectURL(data[f.key])   // new upload
//     : data[`${f.key}Url`] 

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="xs"
//       className="py-10"
//       scroll="paper"
//     >
//       <DialogTitle align="center">Upload KYC Documents</DialogTitle>

//       <DialogContent dividers>
//         <TextField
//           fullWidth
//           label="Aadhaar Number"
//           name="aadhaar"
//           value={data.aadhaar}
//           onChange={handleChange}
//           placeholder="Enter 12-digit Aadhaar"
//           sx={{ mb: 2 }}
//           inputProps={{ maxLength: 12 }}
//         />

//         <TextField
//           fullWidth
//           label="PAN Number"
//           name="pan"
//           value={data.pan}
//           onChange={handleChange}
//           placeholder="Enter PAN (ABCDE1234F)"
//           sx={{ mb: 2 }}
//         />

//         {[
//           { key: "aadhaarFront", label: "Aadhaar Front" },
//           { key: "aadhaarBack", label: "Aadhaar Back" },
//           { key: "panFile", label: "PAN Card" }
//         ].map((f) => (
//           <Box key={f.key} sx={{ mb: 2 }}>
//             <label className="text-sm font-medium">{f.label}</label>

//             <input
//               type="file"
//               name={f.key}
//               accept="image/*"
//               onChange={handleFile}
//               className="block w-full text-sm mt-1"
//             />

//             {/* {data[f.key] && (
//               <img
//                 src={URL.createObjectURL(data[f.key])}
//                 alt="preview"
//                 style={{
//                   marginTop: 8,
//                   width: "100%",
//                   height: 130,
//                   objectFit: "cover",
//                   borderRadius: 8,
//                   border: "1px solid #ddd"
//                 }}
//               />
//             )} */}
//             {previewSrc && (
//   <img
//     src={previewSrc}
//     alt="preview"
//     style={{
//       marginTop: 8,
//       width: "100%",
//       height: 130,
//       objectFit: "cover",
//       borderRadius: 8,
//       border: "1px solid #ddd"
//     }}
//   />
// )}

//           </Box>
//         ))}
//       </DialogContent>

//       <DialogActions sx={{ px: 3, pb: 2 }}>
//         <Button onClick={onClose} color="inherit">
//           Cancel
//         </Button>
//         <Button variant="contained" onClick={submit}>
//           Save Documents
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default KycUploadModal;



import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNotify } from "../../context/NotifyContext";


const KycUploadModal = ({ open, onClose, onSubmit, initialData }) => {
  const {notify} = useNotify(); // ✅ Notification hook

  const [data, setData] = useState({
    aadhaar: "",
    pan: "",

    aadhaarFront: null,
    aadhaarBack: null,
    panFile: null,

    aadhaarFrontUrl: "",
    aadhaarBackUrl: "",
    panFileUrl: ""
  });

  /* ---------- PREFILL FROM BACKEND ---------- */
  useEffect(() => {
    if (initialData) {
      setData(prev => ({
        ...prev,
        ...initialData
      }));
    }
  }, [initialData]);

  /* ---------- INPUT CHANGE ---------- */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "aadhaar") {
      if (/^\d*$/.test(value)) {
        setData(prev => ({ ...prev, aadhaar: value.slice(0, 12) }));
      }
    }

    if (name === "pan") {
      setData(prev => ({ ...prev, pan: value.toUpperCase().trim() }));
    }
  };

  /* ---------- FILE CHANGE ---------- */
  const handleFile = (e) => {
    const { name, files } = e.target;
    setData(prev => ({
      ...prev,
      [name]: files[0]
    }));
  };

  /* ---------- SUBMIT ---------- */
  const submit = () => {
    if (data.aadhaar.length !== 12) {
      return notify("Aadhaar must be 12 digits", "error");
    }

    if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(data.pan)) {
      return notify("Invalid PAN format", "error");
    }

    // ✅ File OR URL (both valid)
    if (
      (!data.aadhaarFront && !data.aadhaarFrontUrl) ||
      (!data.aadhaarBack && !data.aadhaarBackUrl) ||
      (!data.panFile && !data.panFileUrl)
    ) {
      return notify("All documents are required", "error");
    }

    onSubmit(data);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      scroll="paper"
    >
      <DialogTitle align="center">Upload KYC Documents</DialogTitle>

      <DialogContent dividers>
        <TextField
          fullWidth
          label="Aadhaar Number"
          name="aadhaar"
          value={data.aadhaar}
          onChange={handleChange}
          sx={{ mb: 2 }}
          inputProps={{ maxLength: 12 }}
        />

        <TextField
          fullWidth
          label="PAN Number"
          name="pan"
          value={data.pan}
          onChange={handleChange}
          sx={{ mb: 2 }}
        />

        {[
          { key: "aadhaarFront", label: "Aadhaar Front" },
          { key: "aadhaarBack", label: "Aadhaar Back" },
          { key: "panFile", label: "PAN Card" }
        ].map((f) => {
          const previewSrc =
            data[f.key]
              ? URL.createObjectURL(data[f.key])   // new upload
              : data[`${f.key}Url`];              // existing image

          return (
            <Box key={f.key} sx={{ mb: 2 }}>
              <label className="text-sm font-medium">{f.label}</label>

              <input
                type="file"
                name={f.key}
                accept="image/*"
                onChange={handleFile}
                className="block w-full text-sm mt-1 !bg-black"
              />

              {previewSrc && (
                <img
                  src={previewSrc}
                  alt="preview"
                  style={{
                    marginTop: 8,
                    width: "100%",
                    height: 130,
                    objectFit: "cover",
                    borderRadius: 8,
                    border: "1px solid #ddd"
                  }}
                />
              )}
            </Box>
          );
        })}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button variant="contained" onClick={submit}>
          Save Documents
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KycUploadModal;
